module.exports = __webpack_public_path__ + "static/media/tournament-thumb.f4cc3485.png";